<span matSnackBarLabel class="flex flex-col gap-4">
  @for (messageObj of messageObjs; track messageObj) {
    <div class="flex flex-col">
      <div>{{ messageObj.message }}</div>
      <ul class="list-disc ml-6">
        @for (item of messageObj.messageList; track item) {
          <li>{{ item }}</li>
        }
      </ul>
    </div>
  }
</span>
<span matSnackBarActions>
  <button mat-button matSnackBarAction (click)="snackBarRef.dismissWithAction()">Dismiss</button>
</span>
